import { createApi } from '@reduxjs/toolkit/query/react';
import { fileUploadBaseQueryWithReauth } from './utils';

const TICKET_URL = '/tickets';

export const fileuploadApi = createApi({
    reducerPath: 'fileuploadApi',
    baseQuery: fileUploadBaseQueryWithReauth,
    endpoints: builder => ({
        multipleAttachmentUpload: builder.query({
            query: ({ params }) => {
                return {
                    url: `${TICKET_URL}/multiple_attachment_upload_url`,
                    method: 'GET',
                    params,
                };
            },
        }),
    }),
});

export const {
    useLazyMultipleAttachmentUploadQuery,
} = fileuploadApi;
